import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import "./InputSearchs.css";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import baseURL from '../url';
import { useMediaQuery } from '@react-hook/media-query';
export default function InputSearchs() {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const isScreenLarge = useMediaQuery('(min-width: 1024px)');
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState({});
    const routerLocation = useLocation();
    useEffect(() => { try { Modal.setAppElement('#root'); } catch(_){} }, []);
    const closeAllOverlays = () => { try { window.dispatchEvent(new Event('close-all-overlays')); } catch (_) {} };
    useEffect(() => {
        cargarProductos();
        cargarCategorias();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, { method:'GET', cache:'no-store', headers:{ 'Accept':'application/json' } })
            .then(r=>r.text())
            .then(t=>{ try{ const data=JSON.parse(t); setProductos(data.productos||[]); }catch(_){ setProductos([]);} })
            .catch(()=>{});
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method:'GET', cache:'no-store', headers:{ 'Accept':'application/json' } })
            .then(r=>r.text())
            .then(t=>{ try{ const data=JSON.parse(t); setCategorias(data.categorias||[]); }catch(_){ setCategorias([]);} })
            .catch(()=>{});
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);

        const filteredResults = categorias.map((categoria) => {
            const productosFiltrados = productos.filter((producto) => {
                return (
                    producto.idCategoria === categoria.idCategoria &&
                    (producto.titulo.toLowerCase().includes(searchTerm) ||
                        categoria.categoria.toLowerCase().includes(searchTerm))
                );
            });

            return productosFiltrados.length > 0 ? { categoria, productos: productosFiltrados } : null;
        }).filter(result => result !== null);

        setFilteredResults(filteredResults);
        setShowResults(searchTerm !== "");
        setNoResults(searchTerm !== "" && filteredResults.length === 0);
    };
    const handleShowMore = (categoria) => {
        setVisibleProducts(prev => ({
            ...prev,
            [categoria?.idCategoria]: (prev[categoria?.idCategoria] || 5) + 5
        }));
    };

    const openModal = () => {
        closeAllOverlays();
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setSearchTerm('');
        setShowResults(false);
    };

    useEffect(() => {
        const onCloseAll = () => setModalIsOpen(false);
        window.addEventListener('close-all-overlays', onCloseAll);
        return () => window.removeEventListener('close-all-overlays', onCloseAll);
    }, []);

    useEffect(() => {
        setModalIsOpen(false);
    }, [routerLocation.pathname, routerLocation.search]);

    useEffect(() => {
        const onKey = (e) => {
            if (modalIsOpen && e.key === 'Escape') {
                closeModal();
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [modalIsOpen]);

    return (
        <div className="fondo-input">

            {isScreenLarge ?
                <div className="search-container">
                    <fieldset className="inputSearch">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="input"
                        />
                    </fieldset>
                    {showResults && (
                        <div className="modalSearch">
                            {filteredResults.map(({ categoria, productos }) => (
                                <div key={categoria.idCategoria} className="sectionSearch">
                                    <h3>{categoria.categoria}</h3>
                                    <hr />
                                    {productos?.slice(0, visibleProducts[categoria?.idCategoria] || 5).map((producto) => (
                                        <div key={producto.idProducto}>
                                            <a href={`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                {renderPicture(obtenerImagen(producto), producto.producto || 'Producto', { width:'100px', height:'100px', objectFit:'cover' })}
                                                <p>{producto.titulo}</p>
                                            </a>
                                        </div>
                                    ))}
                                    {productos?.length > (visibleProducts[categoria?.idCategoria] || 5) && (
                                        <button onClick={() => handleShowMore(categoria)} className="show-more-btn2">Mostrar más</button>
                                    )}
                                </div>
                            ))}
                            {noResults && <p>No se encontraron resultados.</p>}
                        </div>
                    )}
                </div>
                :
                <div className="search-container">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" onClick={openModal} />
                    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} className="modalInput" overlayClassName="overlayInput" closeTimeoutMS={300} ariaHideApp={false}>
                        <fieldset className="inputSearch">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                type="text"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={handleSearch}
                                className="input"
                            />
                            <button onClick={closeModal} className="close-btn" aria-label="Cerrar">X</button>
                        </fieldset>
                        {showResults && (
                            <div className="modalSearch">
                                <button onClick={closeModal} className="close-btn" aria-label="Cerrar">X</button>
                                {filteredResults.map(({ categoria, productos }) => (
                                    <div key={categoria.idCategoria} className="sectionSearch">
                                        <h3>{categoria.categoria}</h3>
                                        <hr />
                                        {productos?.slice(0, visibleProducts[categoria?.idCategoria] || 5).map((producto) => (
                                            <div key={producto.idProducto}>
                                                <Link to={`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                    {renderPicture(obtenerImagen(producto), producto.producto || 'Producto', { width:'100px', height:'100px', objectFit:'cover' })}
                                                    <p>{producto.titulo}</p>
                                                </Link>
                                            </div>
                                        ))}
                                        {productos?.length > (visibleProducts[categoria?.idCategoria] || 5) && (
                                            <button onClick={() => handleShowMore(categoria)} className="show-more-btn2">Mostrar más</button>
                                        )}
                                    </div>
                                ))}
                                {noResults && <p>No se encontraron resultados.</p>}
                            </div>
                        )}
                    </Modal>
                </div>

            }

        </div>
    );
}
    const renderPicture = (rawSrc, altText, style) => {
        const resolveImage = (raw) => {
            try{
                if (!raw) return `${baseURL}/logo.png`;
                if (/^https?:\/\//i.test(raw)){
                    const url = new URL(raw);
                    return `${baseURL}/${String(url.pathname||'').replace(/^\//,'')}`;
                }
                return `${baseURL}/${String(raw||'').replace(/^\//,'')}`;
            }catch(_){ return `${baseURL}/logo.png`; }
        };
        const toNum = (v)=>{
            if (typeof v === 'number') return v;
            if (typeof v === 'string' && /px$/.test(v)) { try{ return parseInt(v,10); }catch(_){ return undefined; } }
            return undefined;
        };
        const src = resolveImage(rawSrc);
        const w = toNum(style?.width);
        const h = toNum(style?.height);
        const fallback = `${baseURL}/logo.png`;
        return (
            <img
              loading="lazy"
              decoding="async"
              src={src}
              alt={altText}
              style={style}
              width={w}
              height={h}
              onError={(e)=>{ try{ e.currentTarget.src = fallback; }catch(_){ } }}
            />
        );
    };

    const obtenerImagen = (item) => {
        for (let i = 1; i <= 14; i++) {
            const key = `imagen${i}`;
            if (item?.[key]) return item[key];
        }
        return null;
    };
